// extracted by mini-css-extract-plugin
module.exports = {"title":"header_title__1DXxp","prev":"header_prev__3f4ir","next":"header_next__1aCLW"};